import TopLoadCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['extras', 'topload_needed'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { topload_needed: topLoadNeeded, extras = [] } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );
    return {
      topLoadNeeded: topLoadNeeded || extras.indexOf('TOP_LOAD') >= 0,
    };
  })
);

export default enhance(TopLoadCell);
